var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewsOverTimeTableRaw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 261,
    height: 271.365,
    viewBox: "0 0 261 271.365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3108",
    "data-name": "Group 3108",
    transform: "translate(-1475 -2345)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 260.838,
    height: 271.365,
    transform: "translate(1475.162 2345)",
    fill: "#f8f8f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x2: 260.728,
    transform: "translate(1475.026 2385.81)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x2: 260.728,
    transform: "translate(1475.026 2405.01)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    x2: 260.728,
    transform: "translate(1475.026 2424.209)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x2: 260.728,
    transform: "translate(1475.026 2443.408)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    x2: 260.728,
    transform: "translate(1475 2462.608)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    x2: 260.728,
    transform: "translate(1475.026 2481.807)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    x2: 260.728,
    transform: "translate(1475.026 2501.007)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    x2: 260.728,
    transform: "translate(1475.026 2520.206)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    x2: 260.728,
    transform: "translate(1475.026 2539.406)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    x2: 260.728,
    transform: "translate(1475.026 2558.605)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x2: 260.728,
    transform: "translate(1475.026 2577.804)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M0,0H260.728",
    transform: "translate(1475.026 2597.548)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    x2: 260.728,
    transform: "translate(1475.026 2366.611)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "_2019",
    "data-name": 2019,
    transform: "translate(1674.557 2358.491)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2019")), /*#__PURE__*/React.createElement("text", {
    id: "_2020",
    "data-name": 2020,
    transform: "translate(1590.371 2358.491)",
    fill: "#74ad85",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2020")), /*#__PURE__*/React.createElement("text", {
    id: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec_Avg.",
    "data-name": "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec Avg.",
    transform: "translate(1519.338 2379.181)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -19.77,
    y: 0
  }, "Jan"), /*#__PURE__*/React.createElement("tspan", {
    x: -19.723,
    y: 19.4
  }, "Feb"), /*#__PURE__*/React.createElement("tspan", {
    x: -21.064,
    y: 38.8
  }, "Mar"), /*#__PURE__*/React.createElement("tspan", {
    x: -18.621,
    y: 58.2
  }, "Apr"), /*#__PURE__*/React.createElement("tspan", {
    x: -22.682,
    y: 77.6
  }, "May"), /*#__PURE__*/React.createElement("tspan", {
    x: -19.857,
    y: 97
  }, "Jun"), /*#__PURE__*/React.createElement("tspan", {
    x: -16.148,
    y: 116.4
  }, "Jul"), /*#__PURE__*/React.createElement("tspan", {
    x: -21.111,
    y: 135.8
  }, "Aug"), /*#__PURE__*/React.createElement("tspan", {
    x: -20.209,
    y: 155.2
  }, "Sep"), /*#__PURE__*/React.createElement("tspan", {
    x: -18.451,
    y: 174.6
  }, "Oct"), /*#__PURE__*/React.createElement("tspan", {
    x: -21.123,
    y: 194
  }, "Nov"), /*#__PURE__*/React.createElement("tspan", {
    x: -20.508,
    y: 213.4
  }, "Dec"), /*#__PURE__*/React.createElement("tspan", {
    x: -23.238,
    y: 232.8
  }, "Avg.")), /*#__PURE__*/React.createElement("text", {
    id: "_21_16_7_10_16_34_23_21_19_32_36_27_27",
    "data-name": "21 16 7 10 16 34 23 21 19 32 36 27 27",
    transform: "translate(1597.518 2379.551)",
    fill: "#74ad85",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 0
  }, "21"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 19.4
  }, "16"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 38.8
  }, "7"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 58.2
  }, "10"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 77.6
  }, "16"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 97
  }, "34"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 116.4
  }, "23"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 135.8
  }, "21"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 155.2
  }, "19"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 174.6
  }, "32"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 194
  }, "36"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 213.4
  }, "27"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 232.8
  }, "27")), /*#__PURE__*/React.createElement("text", {
    id: "_2_0_1_0_7_8_13_11_9_20_18_22_11",
    "data-name": "2 0 1 0 7 8 13 11 9 20 18 22 11",
    transform: "translate(1683.32 2379.551)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 0
  }, "2"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 19.4
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 38.8
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 58.2
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 77.6
  }, "7"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 97
  }, "8"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 116.4
  }, "13"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 135.8
  }, "11"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 155.2
  }, "9"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 174.6
  }, "20"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 194
  }, "18"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 213.4
  }, "22"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 232.8
  }, "11")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_330",
    "data-name": "Ellipse 330",
    cx: 4.281,
    cy: 4.281,
    r: 4.281,
    transform: "translate(1576.021 2350.938)",
    fill: "#74ad85"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_331",
    "data-name": "Ellipse 331",
    cx: 4.281,
    cy: 4.281,
    r: 4.281,
    transform: "translate(1662.061 2350.938)",
    fill: "#e6e7e8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewsOverTimeTableRaw);
export default __webpack_public_path__ + "static/media/reviewsOverTimeTableRaw.0b6e1815.svg";
export { ForwardRef as ReactComponent };